export default {
  'keep-title': '@:terms.keep',
  'login-for-kakao': 'login for @:terms.kakao',
  'subtitle': 'for all owners',
}
